import React, { useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Card } from "./styles";
import MilkTransaction from "./Transactions/MilkTransaction";
import GuestTransaction from "./Transactions/GuestTransaction";
import VechileTransaction from "./Transactions/VechileTransaction";
import MaterialInward from "./Transactions/MaterialInward";
import KeyTransaction from "./Transactions/KeyTransaction";
import MaterialOutward from "./Transactions/MaterialOutward";
import MaterialReturnable from "./Transactions/MaterialReturnable";
import CustomDivider from "../../components/Components/CustomDivider"

function TransactionEditing({ setModelToggle }) {
  const [stepper, setStepper] = useState("DASHBOARD");
  const [module, setModule] = useState("");

  console.log({ module });

  return (
    <>
      {stepper && stepper === "DASHBOARD" && (
        <Grid
          container
          width={"100%"}
          justifyContent={"center"}
          columnGap={4}
          rowGap={4}
          style={{ paddingBottom: '2%' }}
        >
          <Grid item container justifyContent={"center"} py={2}>
            <h4>Transaction Editing</h4>
            <CustomDivider />
          </Grid>
          {/* <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("GUEST");
              setStepper("TABLE");
            }}
          >
            <Grid item xs={12}>
              Guests
            </Grid>
          </Card> */}
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("MILK");
              setStepper("TABLE");
            }}
          >
            {/* <img src={AavinImage} alt="cow" height={50} width={50} /> */}
            <Grid item xs={12}>
              Milk
            </Grid>
          </Card>
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("VECHILE");
              setStepper("TABLE");
            }}
          >
            {/* <img src={AavinImage} alt="cow" height={50} width={50} /> */}
            <Grid item xs={12}>
              Vechile
            </Grid>
          </Card>
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("MATERIAL_INWARD");
              setStepper("TABLE");
            }}
          >
            <Grid item xs={12}>
              Material Inwards
            </Grid>
          </Card>
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("MATERIAL_OUTWARD");
              setStepper("TABLE");
            }}
          >
            <Grid item xs={12}>
              Material Outwards
            </Grid>
          </Card>
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("MATERIAL_RETURNABLE");
              setStepper("TABLE");
            }}
          >
            <Grid item xs={12}>
              Material Returnable
            </Grid>
          </Card>
          <Card
            item
            container
            xs={3}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={() => {
              setModule("KEY_MANAGEMENT");
              setStepper("TABLE");
            }}
          >
            <Grid item xs={12}>
              Keys
            </Grid>
          </Card>
        </Grid>
      )}

      {stepper === "TABLE" && (
        <Grid container xs={12} width={"100%"}>
          {(() => {
            switch (module) {
              case "MILK":
                return <MilkTransaction />;
              case "GUEST":
                return <GuestTransaction />;
              case "VECHILE_MANAGEMENT":
                return <VechileTransaction />;
              case "MATERIAL_INWARD":
                return <MaterialInward />;
              case "KEY_MANAGEMENT":
                return <KeyTransaction />;
              case "MATERIAL_OUTWARD":
                return <MaterialOutward />;
              default:
                return <MaterialReturnable />;
            }
          })()}
        </Grid>
      )}
    </>
  );
}

export default TransactionEditing;
